<template>
  <fragment>
    <div v-if="!survey" class="page">
      <div class="page-header">
        <h1>All of your active self-assessment surveys are complete.</h1>
      </div>
    </div>
    <survey-initial-cra-apob ref="cra" v-if="survey.type == productType.InitialCRAAPOB || survey.type == productType.InitialCRALDLP || survey.type == productType.InitialCRAHOMAIR" />
    <survey-repeated-cra ref="repeatedCRA" v-if="survey.type == productType.RepeatedCRAAPOB || survey.type == productType.CondensedRepeatedCRAAPOB || survey.type == productType.RepeatedCRALDLP || survey.type == productType.RepeatedCRAHOMAIR" />
    <survey-initial-dra ref="initial" v-else-if="survey.type == productType.InitialDRA" />
    <survey-repeated-dra ref="repeated" v-else-if="survey.type == productType.RepeatedDRA" />
    <survey-advanced-initial-cra prefix="advancedCra" v-if="survey.type == productType.AdvancedCRAAPOB || survey.type == productType.RepeatedAdvancedCRAAPOB" :type="survey.type" />
  </fragment>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapActions, mapState } = createNamespacedHelpers('survey');

  import productType from 'enums/product-type';

  import SurveyInitialDra from './survey-initial/survey-initial.vue';
  import SurveyRepeatedDra from './survey-repeated/survey-repeated.vue';
  import SurveyInitialCraApob from './survey-cra/survey-initial-cra-apob.vue';
  import SurveyRepeatedCra from './survey-cra/survey-repeated-cra.vue';
  import SurveyAdvancedInitialCra from './survey-cra/survey-advanced-cra.vue'

  import jwtDecode from "jwt-decode";

  export default {
    components: {
      SurveyInitialDra,
      SurveyRepeatedDra,
      SurveyInitialCraApob,
      SurveyRepeatedCra,
      SurveyAdvancedInitialCra
    },

    data() {
      return {
        productType: productType
      }
    },

    computed: {
      ...mapState(["survey"])
    },

    methods: {
      ...mapActions(["get"]),
    },

    async mounted() {
      const userAuth = jwtDecode(this.$auth.tokenData.accessToken);

      if (userAuth.report_to_edit_id) {
        await this.get(userAuth.report_to_edit_id);
      }
      else {
        await this.get();
      }

      this.$refs.cra?.setStep(this.survey.lastStep || 0);
      this.$refs.repeatedCRA?.setStep(this.survey.lastStep || 0);
      this.$refs.initial?.setStep(this.survey.lastStep || 0);
      this.$refs.repeated?.setStep(this.survey.lastStep || 0);
    }
  }
</script>